export const CURRENCIES = [
    { code: "TRY", label: "₺ TRY" },
    { code: "USD", label: "$ USD" },
    { code: "EUR", label: "€ EUR" },
    { code: "GBP", label: "£ GBP" }
];

export const CARD_TYPES = [
    "WORLD",
    "AXESS",
    "MAXIMUM",
    "CARDFINANS",
    "PARAF",
    "ADVANTAGE",
    "COMBO",
    "BONUS",
    "SAGLAMKART",
    "STANDART"
];

export const ACCOUNT_TYPES = [
    { value: "SOLE_PROPRIETORSHIP", label: "Şahıs Şirketi" },
    { value: "JOINT_STOCK_COMPANY", label: "Anonim Şirket" },
    { value: "LIMITED_COMPANY", label: "Limited Şirket" },
    { value: "COOPERATIVE", label: "Kooperatif" },
    { value: "GENERAL_PARTNERSHIP", label: "Kolektif Şirket" },
    { value: "COMMANDITE_COMPANY", label: "Komandit Şirket" }
];

export const MAX_INSTALLMENTS = 12;

// Banka kartı (STANDART) kapalı başlar; oran çekmek açmaz, yalnız elle açılır.
export const defaultInstallmentEnabled = (card) => card !== "STANDART";


export const TURKISH_BANKS = [
    "Akbank",
    "Alternatif Bank",
    "Anadolubank",
    "Arap Türk Bankası",
    "Burgan Bank",
    "Denizbank",
    "Fibabanka",
    "Garanti BBVA",
    "HSBC",
    "ING",
    "İş Bankası",
    "Kuveyt Türk",
    "Odeabank",
    "QNB Finansbank",
    "Şekerbank",
    "TEB",
    "Turkish Bank",
    "Türk Ekonomi Bankası",
    "Türkiye Finans",
    "Vakıfbank",
    "Yapı Kredi",
    "Ziraat Bankası",
];